module.exports = __webpack_public_path__ + "img/company_05.bb9523f0.png";